module.exports = __webpack_public_path__ + "media/shape/testimonial-02-cee003aa.png";